import { iranianBanks } from "../../lib/constants";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteSavedIban } from "../../lib/queries/queriesAndMutations";
import Popup from "reactjs-popup";
import SavedIbanForm from "../forms/SavedIbanForm";
import Loader from "../../shared/Loader";
import icons from "../../lib/icons";
import CopyButton from "../../ui/CopyButton";
import { useNavigate } from "react-router-dom";

const SavedIbanCart = ({ savedIban }) => {
  const navigate = useNavigate();
  const { mutateAsync: deleteSavedIban, isPending } = useDeleteSavedIban();
  const queryClient = useQueryClient();
  const handleDeleteApiKey = async (id) => {
    try {
      const response = await deleteSavedIban(id);
      if (response.status === 200) {
        toast.success("عملیات موفق");
        queryClient.invalidateQueries({ queryKey: ["getDestinationIbans"] });
      }
    } catch (error) {
      console.error("Error processing form:", error);
    }
  };
  return (
    <div className="flex flex-col bg-primary-20 rounded-[12px] p-[10px] w-fit min-w-[400px] gap-5  ">
      <div
        key={savedIban.destination_iban}
        className="flex items-center gap-2  cursor-pointer"
      >
        {renderBankLogo(savedIban)}

        <p className="flex-1 font-semibold text-[12px]">
          {savedIban.iban_nickname}
        </p>
      </div>

      <p className="text-[16px] mx-auto text-dark  ">{savedIban.iban}</p>

      <div className="flex gap-2 w-fit mr-auto">
        <button
          className="dark-btn flex items-center "
          onClick={() =>
            navigate("/withdrawals/transfer", {
              state: {
                iban: savedIban.iban.slice(2),
                iban_nickname: savedIban.iban_nickname,
              },
            })
          }
        >
          <p>انتقال وجه</p>
          <img src={icons.withdraw} alt="edit-icon" width={16} height={16} />
        </button>
        <Popup
          trigger={
            <button
              className="dark-btn flex items-center gap-1 mr-auto"
              onClick={() => handleDeleteApiKey(savedIban.id)}
            >
              <p>ویرایش</p>
              <img src={icons.edit} alt="edit-icon" width={16} height={16} />
            </button>
          }
          modal
          nested
        >
          {(close) => (
            <SavedIbanForm close={close} formType={"update"} data={savedIban} />
          )}
        </Popup>
        <CopyButton copyText={savedIban.iban} />

        {!isPending ? (
          <button
            onClick={() => handleDeleteApiKey(savedIban.id)}
            className="red-btn flex items-center gap-1 mr-auto"
          >
            <p>حذف</p>
            <img
              src={icons.trash}
              alt="edit-icon"
              width={16}
              height={16}
            />{" "}
          </button>
        ) : (
          <div className="w-6 h-6">
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default SavedIbanCart;

const renderBankLogo = (bank) => {
  const bankData = iranianBanks.find(
    (entry) => entry.code === bank?.iban_bank_code
  );

  if (bankData?.src) {
    return (
      <img
        src={`/banks/${bankData.src}-300-wc.png`}
        alt={`${bank?.iban_bank_name} Logo`}
        title={bank?.iban_bank_name}
        className="w-8 h-8 "
      />
    );
  }

  return (
    <div className="w-fit h-8 bg-neutral-20 rounded-full text-[8px] flex justify-center items-center">
      {bank?.iban_bank_name || " "}
    </div>
  );
};
